export default __webpack_public_path__ + "static/media/error-icon.0935d066.svg";